const SvgAuthApple = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_13217_5873)">
        <path
          d="M21.2856 7.82836C21.1872 7.88996 18.8448 9.18996 18.8448 12.0724C18.9552 15.3596 21.8008 16.5124 21.8496 16.5124C21.8008 16.574 21.42 18.0828 20.292 19.6644C19.3968 21.0268 18.4032 22.4004 16.8944 22.4004C15.4592 22.4004 14.944 21.4924 13.288 21.4924C11.5096 21.4924 11.0064 22.4004 9.64478 22.4004C8.13598 22.4004 7.06878 20.9532 6.12478 19.6036C4.89838 17.8372 3.85598 15.0652 3.81918 12.4036C3.79438 10.9932 4.06478 9.60676 4.75118 8.42916C5.71998 6.78516 7.44958 5.66916 9.33838 5.63236C10.7856 5.58356 12.0736 6.62596 12.9568 6.62596C13.8032 6.62596 15.3856 5.63236 17.176 5.63236C17.9488 5.63316 20.0096 5.86596 21.2856 7.82836ZM12.8344 5.35076C12.5768 4.06276 13.288 2.77476 13.9504 1.95316C14.7968 0.959556 16.1336 0.285156 17.2864 0.285156C17.36 1.57316 16.8936 2.83636 16.06 3.75636C15.312 4.74996 14.024 5.49796 12.8344 5.35076Z"
          fill="#5B5B5B"
        />
      </g>
      <defs>
        <clipPath id="clip0_13217_5873">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.833496)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgAuthApple;
